import { useCallback } from 'react';

import qs from 'qs';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { useSession } from 'src/app/shared/hooks/session';

type Result = (options: { pathSuffix?: string; medium: string; additionalParams?: Record<string, string> }) => string;

export function useGenPetitionUrl(): Result {
	const session = useSession();
	const {
		data: {
			petition: { slug, bestShareVisual },
			hideRecruiterEnabled,
			isShareAssetsEnabled,
		},
	} = usePsfPromoteOrSharePageData();

	const sessionUuid = session.uuid;
	const currentUserId = session.user?.id || undefined;
	const currentCampaign = session.trackingData.current_campaign || undefined;

	return useCallback(
		({ pathSuffix, medium, additionalParams }) => {
			// No isMobile gate — promoteOrShare is a mobile-only flow
			const shouldUseBsvPath = isShareAssetsEnabled && !!bestShareVisual?.url;
			const effectivePathSuffix = shouldUseBsvPath ? `${pathSuffix ?? ''}/bsv` : (pathSuffix ?? '');

			const trackParams = qs.stringify(
				{
					...(hideRecruiterEnabled
						? {}
						: {
								recruiter: currentUserId || undefined,
								recruited_by_id: sessionUuid,
							}),
					utm_source: 'share_petition',
					utm_campaign: 'psf_promote_or_share',
					utm_term: currentCampaign,
					utm_medium: medium,
					...additionalParams,
				},
				{ encodeValuesOnly: true },
			);
			return `/p/${slug}${effectivePathSuffix}?${trackParams}`;
		},
		[
			sessionUuid,
			currentUserId,
			slug,
			currentCampaign,
			hideRecruiterEnabled,
			isShareAssetsEnabled,
			bestShareVisual?.url,
		],
	);
}
